var map = {
	"./banners/de_main-image.json": [
		588,
		25
	],
	"./banners/de_promoted_offers.json": [
		589,
		26
	],
	"./banners/it_main-image.json": [
		590,
		27
	],
	"./banners/it_promoted_offers.json": [
		591,
		28
	],
	"./main-image.json": [
		592,
		29
	],
	"./promoted_offers.json": [
		593,
		30
	],
	"./slider.json": [
		582,
		31
	],
	"./slider_archive.json": [
		594,
		32
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 312;
module.exports = webpackAsyncContext;